const validate = (values, { t }) => {
  const errors = {};
  if (!values.relatedObjects) {
    errors.relatedObjects = t('validations.required');
  }
  if (values.analysisItems && values.analysisItems.length) {
    values.analysisItems.forEach((item) => {
      const hasContent = item.analysisContent;
      if (!hasContent) {
        const fieldName = item.id;
        errors[fieldName] = t('validations.required');
      }
    });
  }
  return errors;
};

export default validate;
